export default class {
	static breakpoints = {
		sm: window.innerWidth <= 576,
		md: window.innerWidth <= 768,
		lg: window.innerWidth <= 992,
		xl: window.innerWidth <= 1200,
		xxl: window.innerWidth >= 1400
	};
}
